export const baseDocsLink = "https://www.arkosjs.com";
